const images = [
  "https://images.pexels.com/photos/36380795/pexels-photo-36380795.jpeg",
  "https://images.pexels.com/photos/8442034/pexels-photo-8442034.jpeg",
  "https://images.pexels.com/photos/10987574/pexels-photo-10987574.jpeg",
  "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=900&q=80",
  "https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?w=900&q=80",
  "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=900&q=80",
  "https://images.unsplash.com/photo-1551076805-e1869033e561?w=900&q=80",
  "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=900&q=80",
  "https://images.unsplash.com/photo-1584467735815-f778f274e296?w=900&q=80",
];

export const Gallery = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="gallery-page">
    <span className="eyebrow">Gallery</span>
    <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-semibold text-[#0A3B32] tracking-tight max-w-4xl">
      Inside BIOMAC — sessions, labs, and student life.
    </h1>

    <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="gallery-grid">
      {images.map((src, i) => (
        <div key={i} className="overflow-hidden rounded-2xl group" data-testid={`gallery-${i}`}>
          <img
            src={src}
            alt=""
            className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      ))}
    </div>
  </div>
);
